import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { WorkflowStepService } from '../../workflow-step.service';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { take } from 'rxjs/operators';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { AutomataService, RunningState } from '@vendasta/automata';
import { AutomationInterface } from '@vendasta/automata/lib/_internal/interfaces/automation.interface';
import { AutomationErrorHandlerService } from '../../services';
import { CurrentAutomationService } from '@galaxy/automata/shared';

@Component({
  selector: 'automata-snippet-modal',
  templateUrl: './save-snippet-modal.component.html',
  styleUrls: ['./save-snippet-modal.component.scss'],
  imports: [
    MatDialogTitle,
    TranslateModule,
    MatDialogContent,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    MatInput,
    ReactiveFormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    FormsModule,
    GalaxyButtonLoadingIndicatorModule,
  ],
})
export class SaveSnippetModalComponent {
  public loading = false;

  public snippetName: string = this.data?.snippetName;
  public groupID = this.data?.groupID;
  snippetDescription = '';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { snippetName: string; groupID: string },
    public dialogRef: MatDialogRef<SaveSnippetModalComponent>,
    private currentAutomationService: CurrentAutomationService,
    private workflowStepService: WorkflowStepService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService,
    private automationService: AutomataService,
    private automationErrorHandlerService: AutomationErrorHandlerService,
  ) {}

  public cancel(): void {
    this.dialogRef.close();
  }

  public saveAsSnippet(): void {
    this.automationService
      .createAutomation(this.modifyAutomationToSaveAsSnippet())
      .pipe(take(1))
      .subscribe({
        next: (succeeded) => {
          if (succeeded) {
            this.dialogRef.close();
            this.snackbarService.openSuccessSnack(this.translateService.instant('AUTOMATIONS.SNIPPET.SUCCESS_MESSAGE'));
          }
        },
        error: (err) => {
          this.automationErrorHandlerService.displayError(err, false);
        },
      })
      .add(() => (this.loading = false));
  }

  private modifyAutomationToSaveAsSnippet(): AutomationInterface {
    const a = this.currentAutomationService.automation();
    const workflow = this.workflowStepService.getWorkflowStepsInGroup(
      this.currentAutomationService.automation()!,
      this.groupID,
    );
    return {
      name: this.snippetName,
      description: this.snippetDescription,
      isSnippetAutomation: true,
      namespace: a?.namespace,
      context: a?.context,
      runningState: RunningState.RUNNING_STATE_RUNNING,
      workflow: workflow,
    } as AutomationInterface;
  }
}
